export const endpoints = {
  UPDATE_BOLTING_DATA_FEEDBACK: `${process.env.REACT_APP_REST_API_ROOT_URL}/update-bolting-operation-feedback`,
};
